import { createFileRoute } from "@tanstack/react-router"
import { KeysAndSecrets } from "modules/settings/components/KeysAndSecrets"
import { Crumb } from "modules/shared/lib/breadcrumbs"

export const Route = createFileRoute("/_base/_auth/settings/keys-and-secrets")({
  component: KeysAndSecrets,
  loader: ({ route: { fullPath } }) => {
    return new Crumb({
      fullPath,
      title: (t) => t("settings.keysAndSecrets.title"),
    })
  },
})
